import { ENTITY_TYPE, EntityType, MEMBERSHIP_MODE, MembershipMode } from '../../models/entity.model';

export type PickerMode = MembershipMode;

export type PickerOwnerFilter = (typeof PICKER_OWNER_FILTER)[keyof typeof PICKER_OWNER_FILTER];

export type PickerMemberFilter = (typeof PICKER_MEMBER_FILTER)[keyof typeof PICKER_MEMBER_FILTER];

export type PickerTypeFilter = PickerOwnerFilter | PickerMemberFilter;

export type PickerSavePayload = PickerConfig;

export interface PickerTypeFilterOption {
  label: string;
  value: PickerTypeFilter;
}

export interface PickerModeView {
  entityLabel: string;
  searchPlaceholder: string;
  title: string;
  typeFilterLabel: string;
  typeFilterOptions: PickerTypeFilterOption[];
  typeFilterTestId: string;
}

export interface PickerLists {
  members?: PickerItem[];
  ownerGroups?: PickerItem[];
  ownerUsers?: PickerItem[];
}

export interface PickerConfig {
  lists: PickerLists;
  mode: PickerMode;
}

export interface PickerItem {
  email?: string;
  id: string;
  label: string;
  selected: boolean;
  type?: EntityType;
}

export const PICKER_FILTER_ALL = 'all';

export const PICKER_OWNER_FILTER = {
  ALL: PICKER_FILTER_ALL,
  APPLICATION_GROUP: 'application-group',
  ENTERPRISE_GROUP: 'organisation-group',
  USER: ENTITY_TYPE.USER,
} as const;

export const PICKER_MEMBER_FILTER = {
  ALL: PICKER_FILTER_ALL,
  SERVICE: ENTITY_TYPE.M2M,
  USER: ENTITY_TYPE.USER,
} as const;

export const PICKER_MODE_VIEWS: Record<PickerMode, PickerModeView> = {
  [MEMBERSHIP_MODE.MEMBERS]: {
    entityLabel: 'members',
    searchPlaceholder: 'Find a member',
    title: 'Members',
    typeFilterLabel: 'Member type',
    typeFilterOptions: [
      { label: 'All', value: PICKER_MEMBER_FILTER.ALL },
      { label: 'Users', value: PICKER_MEMBER_FILTER.USER },
      { label: 'Services', value: PICKER_MEMBER_FILTER.SERVICE },
    ],
    typeFilterTestId: 'member-type-filter',
  },
  [MEMBERSHIP_MODE.OWNERS]: {
    entityLabel: 'owners',
    searchPlaceholder: 'Find an owner',
    title: 'Owners',
    typeFilterLabel: 'Owner type',
    typeFilterOptions: [
      { label: 'All', value: PICKER_OWNER_FILTER.ALL },
      { label: 'Users', value: PICKER_OWNER_FILTER.USER },
      {
        label: 'Groups managed in this application',
        value: PICKER_OWNER_FILTER.APPLICATION_GROUP,
      },
      {
        label: 'Groups managed by your organisation',
        value: PICKER_OWNER_FILTER.ENTERPRISE_GROUP,
      },
    ],
    typeFilterTestId: 'owner-filter',
  },
};
